import { render, staticRenderFns } from "./DropdownColor.vue?vue&type=template&id=54cd91c2&"
import script from "./DropdownColor.vue?vue&type=script&lang=js&"
export * from "./DropdownColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports